import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ViewCounterUpdatedEvent } from 'src/app/models/events/view-counter-updated-event';

@Injectable({
    providedIn: 'root',
})
export class ViewCounterEventsService {
    /**
     * Emis lorsque le compteur d'une bannette est mis à jour.
     */
    public counterUpdated = new Subject<ViewCounterUpdatedEvent>();
}
